import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface NewDealsState {
  newDealEmails: Set<string>;
  setNewDealEmails: (emails: string[]) => void;
  clearNewDealEmails: () => void;
  isNewDeal: (email: string | undefined) => boolean;
}

export const useNewDealsStore = create<NewDealsState>()(
  devtools(
    (set, get) => ({
      newDealEmails: new Set(),
      setNewDealEmails: (emails) => {
        const normalizedEmails = emails.map((e) => e.toLowerCase().trim());
        set({ newDealEmails: new Set(normalizedEmails) });
      },
      clearNewDealEmails: () => set({ newDealEmails: new Set() }),
      isNewDeal: (email) => {
        if (!email) return false;
        return get().newDealEmails.has(email.toLowerCase().trim());
      },
    }),
    { name: 'new-deals-store' },
  ),
);
